import { useEffect, useState } from "react";
import { Download, ExternalLink } from "lucide-react";

export function CalendarExportBanner() {
  const [tok, setTok] = useState("");
  useEffect(() => { setTok(localStorage.getItem("sigortapro-token") || ""); }, []);
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const feedUrl = tok ? `${origin}/api/calendar/renewals.ics?token=${encodeURIComponent(tok)}` : "";
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(feedUrl); setCopied(true); setTimeout(() => setCopied(false), 1800); }
    catch { window.prompt("Kopyalayın:", feedUrl); }
  };
  return (
    <div className="calendar-banner" data-testid="calendar-export-banner" style={{ background: "linear-gradient(135deg,#eff6ff,#e3edff)", border: "1px solid #bfdbfe", borderRadius: 10, padding: "14px 16px", display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
      <div style={{ flex: 1, minWidth: 200 }}>
        <strong style={{ display: "block", color: "#1447b8", fontSize: 13 }}>Takvime Ekle (iCal)</strong>
        <small className="muted">Google / Apple Takvim'e abone olun — her yenileme otomatik düşsün.</small>
      </div>
      <a className="outline-button" data-testid="calendar-ics-download" href={feedUrl} download="sigortacrm-renewals.ics">
        <Download size={14} /> .ics indir
      </a>
      <button className="primary-button" data-testid="calendar-ics-copy" onClick={copy} disabled={!feedUrl}>
        {copied ? "Kopyalandı ✓" : (<><ExternalLink size={14} /> Abone linkini kopyala</>)}
      </button>
    </div>
  );
}
